import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsConektaComponent } from './simple-icons-conekta.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsConektaComponent ],
    exports:      [ SimpleIconsConektaComponent ],
    bootstrap:    []
})
export class SimpleIconsConektaModule {}
